import React, { useState, useEffect } from "react";
import Input from '../components/Input'
import { Link } from 'react-router-dom'
// import Button from '../components/Button'
import AccountLayout from '../layouts/AccountLayout'
import Alert from '../components/Alert';
import { useHistory } from "react-router-dom";
import useFormValidation from "../libs/validation/formvalidation";
import authenticator from "../services/authenticateService";
import { usePost } from "../libs/service/api";
import ValidateAuth from "../libs/validation/forgotPassword-validation";
import commonService from '../services/commonService';
import cookie from "../libs/cookie/client";
import EmailsentModel from '../components/Modals/EmailsentModel';
const ForgotPassword = (props) => {
    // const history = useHistory();
    const userData = commonService.getUserData();
    const [isSending, setIsSending] = useState("")
    const [isLoggedIn, setisLoggedIn] = useState(false)
    const [SentError, setSentError] = useState("")
    const [isOpenEmailsentModal, setIsOpenEmailsentModal] = useState(false);
    // const [loginError, setLoginError] = useState("")
    const INITIAL_STATE = {
        email: "",
    };

    const MailSentmodelopen = () =>{
        setIsOpenEmailsentModal(true)
    }

    const OnSuccess = () => {
        setIsSending(true)

        usePost('/api/auth/forgotpassword?username=' + values.email).then(res => {
            setIsSending(false);
            if (res.data == "Wrong Email") {
                setSentError(res.data)
            } else {
                setSentError("")
                res.email = values.email
                res.userid = res.userid
                res.username = res.name
                res.authorizationKey = res.data
                cookie.setItem('authorizationKey', res.data);
                cookie.setItem('username', res.name);
                cookie.setItem('userid', res.userid);

                if (!SentError) {
                    cookie.setItem('email', values.email);
                    MailSentmodelopen()
                    // setIsOpenEmailsentModal(true)
                    // setPasswordModalVisible(true)
                } else {
                    setSentError(res.data)
                }
            }
            // console.log(res)
            // console.log(res.data)
        });
    }

    const {
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        errors,
        isSubmitting
    } = useFormValidation(INITIAL_STATE, ValidateAuth, OnSuccess);

    const isDisable = () => {
        return isSubmitting || isSending;
    }

    useEffect(() => {
        // if (authenticator.isLoggedIn()) {
        //     history.push('/')
        // }
        setisLoggedIn(authenticator.isLoggedIn())
        setIsSending(false)
    }, []);

    return (
        <AccountLayout>
            {SentError &&
                <Alert type="secondary" heading="Alert" content={SentError} isVisible={true} />
            }
            <div className="mb-4">Can’t log in?</div>
            <form className="account-form" onSubmit={handleSubmit}>
                <Input label="We will send a recovery link to" type="email" placeholder="E-mail"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="email"
                    autoComplete="off"
                    defaultValue={values.email}
                    error={errors.email}
                    haserror={errors.email ? 1 : 0} />

                <div className=" mt-10" role="group">

                    {!isSending && (
                        <button type="submit" onClick={props.onClick} className="bg-primary hover:bg-primary-dark border-primary text-white font-semibold  text-base py-1.5 px-8 rounded-full inline-block border-2  active:border-3 disabled:opacity-50 focus:outline-none w-full mb-4 ">
                            Send recovery link

                        </button>
                    )}

                    {isSending && (
                        <div className="col-3  flex justify-center item-center aheight items-center border-primary text-white font-semibold  text-base  rounded-full  border-2  active:border-3 disabled:opacity-50 focus:outline-none w-full mb-4 " >
                            <div className="snippet py-1.5 px-8" data-title=".dot-pulse">
                                <div className="stage">
                                    <div className="dot-pulse"></div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>

            </form>

            <div className="flex justify-center border-t border-primary-light pt-4 mt-5">
                <Link to="/login/" className="text-primary font-semibold">Return to log in</Link>
            </div>

            <EmailsentModel isOpen={isOpenEmailsentModal}/>
        </AccountLayout>
    )
}

export default ForgotPassword
